module.exports = __webpack_public_path__ + "src/assets/img/visual_stripe-pattern.701aca87.jpg";